export default "__VITE_ASSET__59ced950__"